import { mount } from "@vue/test-utils";
import Help from "@/components/core/Help";

describe("Help test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(Help);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component Help", () => {
    expect(wrapper).toBeDefined();
  });
});
